/* @flow */

import {trigger as edapTrigger} from './edapWrapper';
import type {Shape as MapHitShape} from '../components/MapHit/MapHit';
import type {Shape as HitShape} from '../components/Hit/Hit';

export const LIST_HIT_CLICK = 'search.hit.click';
export const MAP_HIT_CLICK = 'search.map.hit.click';
export const MAP_MARKER_CLICK = 'search.map.property.click';

type HitEdapEventAction =
    | typeof LIST_HIT_CLICK
    | typeof MAP_HIT_CLICK
    | typeof MAP_MARKER_CLICK;

type Hit = MapHitShape | HitShape;

const triggerHitEdapEvent = (
    hit: Hit,
    eventCategory: HitEdapEventAction,
    delayProcessing?: boolean
) => {
    const options = {delayProcessing};
    edapTrigger(
        eventCategory,
        {
            eventlistingids: hit.listingId,
            absoluteposition: hit.absolutePosition.toString(),
            relativeposition: hit.relativePosition.toString(),
            badges: (hit.badges || []).join(',')
        },
        options
    );
};

export const triggerListHitClickEDAPEvent = (hit: Hit) => {
    triggerHitEdapEvent(hit, LIST_HIT_CLICK, true);
};

export const triggerMapHitClickEDAPEvent = (hit: Hit) => {
    triggerHitEdapEvent(hit, MAP_HIT_CLICK, true);
};

export const triggerMarkerClickEDAPEvent = (hit: Hit) => {
    triggerHitEdapEvent(hit, MAP_MARKER_CLICK);
};
